module.exports = __webpack_public_path__ + "static/media/warning-icon.2ee9df1d.svg";